import * as React from "react";
import { PageProps } from "../../../core/ui/pages/Page";
import { ICaseDecisionCreationPresenter } from "../../presenter/CaseDecisionCreationPresenter";
import CaseDecisionCreationForm from "../components/CaseDecisionCreationForm";

export interface Props extends PageProps {}
export interface State extends ICaseDecisionCreationPresenter {}

export default class CaseDecisionCreationPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      organisations,
      caseDecisionTypes,
      caseDecisionTypeId,
      setOrganisationId,
      translate,
      createCaseDecision,
      showCaseDecisionList,
      user,
      setCaseDecisionTypeId,
      store,
      findCourtCaseDetails,
      courtCase,
      selectedOrganisationId,
      courtCaseTypes,
      createCourtCaseModalVisible,
      createCourtCasePopupVisible,
      decisionTypes,
      courtCaseSelectionResult,
      nonExistantCourtCaseNumber,
      uploadedAttachment,
      showCreateCourtCasePopupVisible,
      showCreateCourtCaseModalVisible,
      createCourtCase,
      createAttachment,
      courtCaseConnectionTypeList,
      updateCourtCaseDetailsModalVisibility,
      courtCaseDetailsModalVisible,
      updateCourtCaseSelection,
      selectCaseDecision,
      setInvalidatePublishedCaseDecisions,
      invalidatePublishedCaseDecisionsVisible,
      publishedCaseDecisions,
      onSearch
    } = this.state;
    return (
      <CaseDecisionCreationForm
        translate={translate}
        caseDecisionTypes={caseDecisionTypes}
        organisations={organisations}
        setOrganisationId={setOrganisationId}
        caseDecisionTypeId={caseDecisionTypeId}
        onSubmit={createCaseDecision}
        showCaseDecisionList={showCaseDecisionList}
        user={user}
        setCaseDecisionTypeId={setCaseDecisionTypeId}
        store={store}
        courtCase={courtCase}
        isCreate={true}
        selectedOrganisationId={selectedOrganisationId}
        findCourtCaseDetails={findCourtCaseDetails}
        courtCaseTypes={courtCaseTypes}
        createCourtCaseModalVisible={createCourtCaseModalVisible}
        createCourtCasePopupVisible={createCourtCasePopupVisible}
        decisionTypes={decisionTypes}
        courtCaseSelectionResult={courtCaseSelectionResult}
        nonExistantCourtCaseNumber={nonExistantCourtCaseNumber}
        uploadedAttachment={uploadedAttachment}
        showCreateCourtCasePopupVisible={showCreateCourtCasePopupVisible}
        showCreateCourtCaseModalVisible={showCreateCourtCaseModalVisible}
        createCourtCase={createCourtCase}
        createAttachment={createAttachment}
        courtCaseConnectionTypeList={courtCaseConnectionTypeList}
        updateCourtCaseDetailsModalVisibility={
          updateCourtCaseDetailsModalVisibility
        }
        courtCaseDetailsModalVisible={courtCaseDetailsModalVisible}
        updateCourtCaseSelection={updateCourtCaseSelection}
        selectCaseDecision={selectCaseDecision}
        setInvalidatePublishedCaseDecisions={
          setInvalidatePublishedCaseDecisions
        }
        invalidatePublishedCaseDecisionsVisible={
          invalidatePublishedCaseDecisionsVisible
        }
        publishedCaseDecisions={publishedCaseDecisions}
        onSearch={onSearch}
      />
    );
  }
}
